import { PeopleEmployeeLeaveDto } from "./employee/people-employee-leave.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleLeaveTypeDto {
    id: number;
    name: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employeeLeaves?: PeopleEmployeeLeaveDto[];
}

export interface PeopleLeaveTypeQueryDto extends PeopleQueryBaseDto {
    name?: string;
}